import React, {useState, useEffect} from 'react';
import { register } from '../../utils/auth';
import { useNavigate, Link } from 'react-router-dom';
import { useAuthStore } from '../../winefacts/auth';
import QRCode from '../../../media/login/QR-code.png';
import wineBottle from '../../../media/login/wine-bottle.png';
import wineBottleQR from '../../../media/login/wine-bottle-qr-2.png';

import QRCodeBottle from '../../../media/login/QRCode_round_white.png';
import QRCode1 from '../../../media/login/QRCode_round_white_cheers.png';
import QRCode2 from '../../../media/login/QRCode_round_white_prost.png';
import QRCode3 from '../../../media/login/QRCode_round_white_enjoy.png';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import ReCAPTCHA from "react-google-recaptcha";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import Swal from 'sweetalert2';
import imageCompression from 'browser-image-compression';
import { logout } from '../../utils/auth';
import '../../../css/register.css'

const Toast = Swal.mixin({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
});

function Register() {

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        password2: '',
        winefactsprofile: {
            winery: '',
            acceptance: false,
            imgQrCode: null
        }
    });

    const [isLoading, setIsLoading] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null);
    const [errors, setErrors] = useState({});

    const { t } = useTranslation(); // Initialize useTranslation

    const isLoggedIn = useAuthStore((state) => state.isLoggedIn)
    const navigate = useNavigate()
    const {    executeRecaptcha } = useGoogleReCaptcha();
    let lang_browser = navigator.language.toLowerCase();
    let lang = localStorage.getItem('language') || (lang_browser.startsWith("en") ? "en" : lang_browser);


    const handleImageChange = async (event) => {
        const file = event.target.files[0];
        const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
        };
    
        try {
            const compressedBlob = await imageCompression(file, options);
            // Convert Blob to File and preserve the original file name and type
            const compressedFile = new File(
                [compressedBlob],
                file.name,
                { type: compressedBlob.type }
            );
    
            if (compressedFile) {
                const reader = new FileReader();
                reader.readAsDataURL(compressedFile); // Read the file as a data URL
                setSelectedFile(compressedFile);
            }
    
            setFormData((prev) => ({
                ...prev,
                winefactsprofile: {
                    ...prev.winefactsprofile,
                    [event.target.name]: compressedFile
                }
            }));
        } catch (error) {
            console.error("Image compression error:", error);
        }
        };
    

    const handleChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (name.startsWith('winefactsprofile.')) {
            const wineryField = name.split('.')[1];
            setFormData((prev) => ({
                ...prev,
                winefactsprofile: {
                    ...prev.winefactsprofile,
                    [wineryField]: type === 'checkbox' ? checked : value
                }
            }));

        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    // Google Recaptcha
    const handleRegisterClick = async (e) => {
        e.preventDefault();
        if (!validateForm(formData)) {
            return;
        }
        logout()
        setIsLoading(true);

        // Get the v3 token
        const recaptchaToken = await executeRecaptcha("register");
        // Send token to backend with registration data
        const { error } = await register({ ...formData, recaptcha_token: recaptchaToken });

        if (error) {
            try {
                const errorObj = typeof error === "string" ? JSON.parse(error) : error;
                if (errorObj.email) {
                    setErrors(prev => ({ ...prev, email: errorObj.email[0] }));
                } else {
                    alert(JSON.stringify(error));
                }
            } catch (e) {
                alert(JSON.stringify(error));
            }   
        } else {
            navigate('/login', { state: { activationMessage: true } });
        }
        setIsLoading(false);

    };

    const validateForm = (formData) => {
        const newErrors = {};

        if (!formData.firstName) {
            newErrors.firstName = "First name is required";
        }
        if (!formData.lastName) {
            newErrors.lastName = "Last name is required";
        }
        if (!formData.password) {
            newErrors.password = "Password is required";
        }
        if (formData.password !== formData.password2) {
            newErrors.password2 = "Passwords do not match";
        }
        if (!formData.winefactsprofile.winery) {
            newErrors.winery = "Winery is required";
        }
        if (!formData.winefactsprofile.acceptance) {
            newErrors.acceptance = "You must accept the terms and conditions";
        }
        if (!formData.email) {
            newErrors.email = "Email is required";
        }
        setErrors(newErrors);

        if (formData.winefactsprofile.imgQrCode) {
            const fileSize = formData.winefactsprofile.imgQrCode.size / 1024 / 1024; // Convert size to MB

            if (fileSize > 10) {
            setIsLoading(false);                   
            Toast.fire({
                icon: "error",
                title: t("product.form.messages.productPictureSizeWarning"),
            });
            return false;
            }
        }
        return Object.keys(newErrors).length === 0;
    };



  return (
    <>
        <div className="form-container-1">
            <div className="form-inner-container-1">
                <div className="left-div-1">
                    <h2 className="font">{t("registerPage.headings.welcome")}</h2>
                    <p className="font">{t("registerPage.headings.description")}</p>
                    <img
                        src={wineBottleQR}
                        alt="wine bottle"
                        className="wine-bottle-pic-reg-new"
                    />
                </div>
                <div className="right-div-1">

                    <p className="form-heading-1">{t("registerPage.headings.welcome")}</p>
                    <p className="desc-text">{t("registerPage.headings.description")}</p>
                    <form onSubmit={handleRegisterClick}> 
                        <div className="form-input-container-1">
                        <label htmlFor="firstName" className={`form-label-1 ${errors.firstName ? "error-message-color" : ""}`}>{t("registerPage.labels.firstName")}{errors.firstName && <span className='error-message-color'> {t("registerPage.messages.isRequired")}</span>}</label>
                        <input
                            id="firstName"
                            name="firstName"
                            type="text"
                            className={`form-input-1 ${errors.firstName ? "error-message-border" : ""}`}
                            value={formData.firstName}
                            onChange={handleChange}
                            placeholder=""
                        />
                        </div>

                        <div className="form-input-container-1">
                        <label htmlFor="lastName" className={`form-label-1 ${errors.lastName ? "error-message-color" : ""}`}>{t("registerPage.labels.lastName")}{errors.lastName && <span className='error-message-color'> {t("registerPage.messages.isRequired")}</span>}</label>
                        <input
                            id="lastName"
                            name="lastName"
                            type="text"
                            className={`form-input-1 ${errors.lastName ? "error-message-border" : ""}`}
                            value={formData.lastName}
                            onChange={handleChange}
                            placeholder=""
                        />
                        </div>
                        
                        <div className="form-input-container-1">
                            <label htmlFor="email" className={`form-label-1 ${errors.email ? "error-message-color" : ""}`}>{t("registerPage.labels.email")}{errors.email && <span className='error-message-color'> {t("registerPage.messages.isRequired")}</span>}</label>
                            <input
                                id="email"
                                name="email"
                                type="email"
                                className={`form-input-1 ${errors.email ? "error-message-border" : ""}`}                          
                                value={formData.email}
                                onChange={handleChange}
                                placeholder=""
                            />
                        </div>
                        <div className="form-input-container-1">
                            <label htmlFor="password" className={`form-label-1 ${errors.password ? "error-message-color" : ""}`}>{t("registerPage.labels.password")}{errors.password && <span className='error-message-color'> {t("registerPage.messages.isRequired")}</span>}</label>
                            <input
                                id="password"
                                name="password"
                                type="password"
                                className={`form-input-1 ${errors.password ? "error-message-border" : ""}`}
                                value={formData.password}
                                onChange={handleChange}
                                placeholder=""
                            />
                        </div>

                        <div className="form-input-container-1">
                        <label htmlFor="password2" className={`form-label-1 ${errors.password2 ? "error-message-color" : ""}`}>{t("registerPage.labels.confirmPassword")}{errors.password2 && <span className='error-message-color'> {t("registerPage.messages.pwDoesNotMatch")}</span>}</label>
                        <input
                            id="password2"
                            name="password2"
                            type="password"
                            className={`form-input-1 ${errors.password2 ? "error-message-border" : ""}`}
                            value={formData.password2}
                            onChange={handleChange}
                            placeholder=""
                        />
                        </div>

                        <div className="form-input-container-1">
                            <label htmlFor="winery" className={`form-label-1 ${errors.winery ? "error-message-color" : ""}`}>{t("registerPage.labels.winery")}{errors.winery && <span className='error-message-color'> {t("registerPage.messages.isRequired")}</span>}</label>
                            <input
                                id="winery"
                                name="winefactsprofile.winery"
                                className={`form-input-1 ${errors.winery ? "error-message-border" : ""}`}
                                value={formData.winefactsprofile.winery}
                                onChange={handleChange}
                                placeholder=""
                            />

                        </div>

                        <div className="form-input-container-1 form-adapt-button-left-1">
                            
                            <input
                                id="imgQrCode"
                                name="imgQrCode"
                                type="file"
                                className="file-input"
                                onChange={handleImageChange}
                            />
                            
                            <div >
                                <label htmlFor="imgQrCode" className="file-label">
                                    <span className="file-label-text">{selectedFile ? selectedFile.name : t("registerPage.buttons.uploadQRCodePicture")}</span>
                                </label>
                                <input
                                    id="acceptance"
                                    name="winefactsprofile.acceptance"
                                    type="checkbox"
                                    className="checkbox-input custom-checkbox"
                                    checked={formData.winefactsprofile.acceptance}
                                    onChange={handleChange}
                                />
                                <label htmlFor="acceptance" className={`checkbox-label ${errors.acceptance ? "error-message-color" : ""}`}>{t("registerPage.labels.acceptTerms1")}
                                    <a
                                        className={`${errors.acceptance ? "error-message-color  !important" : ""}`}
                                        href="/terms-conditions"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        >
                                        {t("registerPage.labels.acceptTerms2")}
                                    </a>
                                </label>

                            </div>
                        </div>
                        
                        <div className="form-input-container-1">
                            
                        </div>
                       <div className="form-input-container-1">
                        {isLoading 
                        ? <button disabled className="form-button-submit-1" type="submit">
                            <i className="fas fa-spinner fa-spin"></i>
                            <span className="mr-2">Processing</span>
                            </button>
                        : <button className="form-button-submit-1" type="submit"><span className="mr-2">{t("registerPage.buttons.register")}</span>
                            <i className="fas fa-sign-in" />
                            </button>
                        }
                        </div>
                    </form>
                    <p className='font' style={{marginBottom: "0"}}>
                    {t("registerPage.links.alreadyHaveAccount")} <Link className="sign-up-link" to="/login">{t("registerPage.links.login")}</Link>
                    </p>
                </div>
            </div>
        </div>
    </>
  )
}

export default Register